"use client";

import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { Application, Category, GroupedCategories } from "../../utils/model";
import ApplicationHorizontalListItem from "../ApplicationHorizontalListItem";

interface PlatformApps {
  appsObj: { platform: string; apps: { data: Application[] } }[];
  allCats: GroupedCategories;
  activePlatform?: string;
}

function capitalizeFirstLetter(val: string) {
  if (val == "ios") {
    return "iOS";
  } else {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }
}

const platforms = ["Windows", "Mac", "Android", "iOS"];

const HomepageAppsMostDownloadedTabs: React.FC<PlatformApps> = ({
  appsObj,
  allCats,
  activePlatform,
}) => {
  const [activeTab, setActiveTab] = useState(
    activePlatform
      ? platforms.indexOf(capitalizeFirstLetter(activePlatform))
      : 0
  );
  0;
  const handleTabChange = (_: React.SyntheticEvent, newTab: number) => {
    setActiveTab(newTab);
  };

  const selectedPlatform = platforms[activeTab];
  const selectedAppsSet = appsObj.filter(
    (appPerPlatform) =>
      appPerPlatform.platform === selectedPlatform.toLowerCase()
  );

  // Handle cases where the platform might not have apps
  const selectedApps =
    selectedAppsSet.length > 0 ? selectedAppsSet[0].apps : undefined;

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className="flex flex-row"
      >
        {platforms.map((platform) => (
          <Tab key={platform} label={platform} />
        ))}
      </Tabs>

      {selectedApps && selectedApps.data.length > 0 ? (
        <div className="content w-full grid grid-cols-1 gap-4 py-4">
          <ul>
            {selectedApps.data.map((app, index) => {
              const parent_category = allCats["application"].categories.find(
                (category: Category) =>
                  category.slug == app.parent_category?.slug
              );
              return (
                <ApplicationHorizontalListItem
                  key={app.id}
                  app={app}
                  parent_category={parent_category?.slug || ""}
                  platform={app.platform?.name?.toLowerCase()}
                  classes=""
                  maxWidth=""
                  order={index + 1}
                />
              );
            })}
          </ul>
        </div>
      ) : (
        <div className="content w-full ">
          <div className="bg-slate-300 text-gray-500 whitespace-nowrap text-center w-full my-4 p-6">
            No applications available for {selectedPlatform}.
          </div>
        </div>
      )}
    </>
  );
};

export default HomepageAppsMostDownloadedTabs;
